import { render, staticRenderFns } from "./forbiddenAccess.vue?vue&type=template&id=9f95104e&scoped=true"
import script from "./forbiddenAccess.vue?vue&type=script&lang=js"
export * from "./forbiddenAccess.vue?vue&type=script&lang=js"
import style0 from "./forbiddenAccess.vue?vue&type=style&index=0&id=9f95104e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f95104e",
  null
  
)

export default component.exports